module.exports = __webpack_public_path__ + "static/media/me_mobile.31c390b1.jpg";